import React from 'react';
import '../css/footer.css';

const Footer = () => (
  <footer className="footer bg-dark text-white text-center">
    <div className="footer-container">
      <div className="row">
        <div className="col-md-4 mb-3">
          <h5>Boduroğlu Otomotiv</h5>
          <p>Dudullu OSB, Kadosan Oto Sanayi Sitesi No:6 H Blok No, 34775 Ümraniye/İstanbul</p>
        </div>

        <div className="col-md-4 mb-3">
          <h5>İletişim</h5>
          <p>
            <i className="fa fa-phone me-2"></i>
            <a href="tel:+905545996888" className="footer-link">0554 599 68 88</a>
          </p>
          <p>
            <i className="fa fa-envelope me-2"></i>
            <a href="mailto:iletisim@bodurogluoto.com" className="footer-link">iletisim@bodurogluoto.com</a>
          </p>
        </div>

        <div className="col-md-4 mb-3">
          <h5>Bizi Takip Edin</h5>
          <div className="social-icons">
            <a href="https://www.facebook.com/p/BODURO%C4%9ELU-OTOMOT%C4%B0V-KADOSAN-100067930343875/" target="_blank" rel="noopener noreferrer" className="footer-link">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="https://www.instagram.com/boduroglu_otomotiv/" target="_blank" rel="noopener noreferrer" className="footer-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-link">
              <i className="fab fa-linkedin-in"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="mt-3">
        <p>&copy; {new Date().getFullYear()} Boduroğlu Otomotiv. Tüm hakları saklıdır.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
